export class DurationModel {
  start: Date;
  end: Date;
  duration: number;
  address: string;
}
